"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const lodash_1 = __importDefault(require("lodash"));
const switchTo = (menu, select) => (e) => {
    e.preventDefault();
    select(e.target.value);
    (0, mobx_1.action)(() => lodash_1.default.map(menu, ($val, $key) => lodash_1.default.set(menu, $key, false)))();
    (0, mobx_1.action)(() => lodash_1.default.set(menu, e.target.value, true))();
};
exports.default = (0, mobx_react_1.observer)(({ menu, select, selected }) => (react_1.default.createElement("div", { className: "z-9999 bg-near-white fixed top-0 left-0 right-0 helvetica" },
    react_1.default.createElement("nav", { className: "dt w-100 center tc tl-ns" },
        react_1.default.createElement("span", { className: "dtc v-mid pv2 ph3 w6" },
            react_1.default.createElement("span", { className: "bg-light-red b--light-red ba bw1 pv2 br2 white nav-shadow" },
                react_1.default.createElement("b", { className: "mh2 dn di-ns" }, "Mobx React Form DEMOS"),
                react_1.default.createElement("select", { className: "select", name: "menu", onChange: switchTo(menu, select), defaultValue: selected },
                    react_1.default.createElement("option", { value: "registerMaterial" }, "Register (Material UI)"),
                    react_1.default.createElement("option", { value: "registerSimple" }, "Register (Simple)"),
                    react_1.default.createElement("option", { value: "companyWidgets" }, "Company (React Widgets)"),
                    react_1.default.createElement("option", { value: "companySimple" }, "Company (Simple)"),
                    react_1.default.createElement("option", { value: "nestedFields" }, "Nested Fields"),
                    react_1.default.createElement("option", { value: "fileUpload" }, "File Upload"),
                    react_1.default.createElement("option", { value: "markdown" }, "Markdown"),
                    react_1.default.createElement("option", { value: "dynamicFieldsSelect" }, "Dynamic Fields Select")))),
        react_1.default.createElement("div", { className: "v-mid tr dn dtc-ns cf" },
            react_1.default.createElement("a", { href: "https://www.npmjs.com/package/mobx-react-form", "data-tip": "NPM", className: "dib db fr pa3 f3 light-red" },
                " ",
                react_1.default.createElement("i", { className: "fa fa-archive" })),
            react_1.default.createElement("a", { href: "https://github.com/foxhound87/mobx-react-form", "data-tip": "GitHub", className: "dib db fr pa3 f3 light-red" },
                " ",
                react_1.default.createElement("i", { className: "fa fa-github" })))))));
